exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".half-height[data-v-05079190]{min-height:50vh}.thumbnail-img[data-v-05079190]{overflow:hidden;width:100%;height:100%;top:0;right:0;bottom:0;left:0}.thumbnail-img:focus .has-bg-img[data-v-05079190],.thumbnail-img:hover .has-bg-img[data-v-05079190]{transform:scale(1.2)}.thumbnail-img .has-bg-img[data-v-05079190]{opacity:.9;z-index:3;width:100%;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover;transition:all 1s;background-blend-mode:multiply}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05079190","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/main/Projects.vue
// module id = 295
// module chunks = 0